import { AlertTriangle, Pencil, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ResponsiveDialog } from 'ui';

import { getIsDiscardModalOpen, setIsDiscardModalOpen } from '../../../store/tasksSlice';

export default function TaskDiscardAlertModal() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isDiscardModalOpen = useSelector(getIsDiscardModalOpen);


    const handleCancel = () => {
        dispatch(setIsDiscardModalOpen(false))
    };

    const handleDiscard = () => {
        dispatch(setIsDiscardModalOpen(false));
    };

    const handleChange = (bool: boolean) => {
        dispatch(setIsDiscardModalOpen(bool));
    };

    return (
        <ResponsiveDialog open={isDiscardModalOpen} onOpenChange={handleChange}>
            <ResponsiveDialog.Content
                className="text-textcolor isolate max-w-[440px] m-auto my-0 border-none p-0"
                showClose={false}
                container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper')}
            >
                <div className="w-full text-center p-6 rounded-lg bg-background shadow-lg">
                    <ResponsiveDialog.Title className="p-0">
                        <div className="flex flex-col items-center gap-3 mb-4">
                            <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-amber-100 dark:bg-amber-900/20">
                                <AlertTriangle className="w-6 h-6 text-amber-600 dark:text-amber-400" />
                            </div>
                            <h1 className="text-textcolor text-lg font-semibold">
                                {t('popover.discard_title', 'Unsaved Changes')}
                            </h1>
                        </div>
                    </ResponsiveDialog.Title>

                    <div className="flex flex-col gap-6">
                        <div className="text-center space-y-2">
                            <p className="text-sm text-gray-600 dark:text-textcolor leading-relaxed">
                                {t('popover.discard_message', 'You\'ve added a comment, but your task isn\’t saved yet.')}
                            </p>
                            <p className="text-xs text-gray-500 dark:text-textcolor bg-gray-50 dark:bg-card px-3 py-2 rounded-md">
                                <strong>{t('popover.discard_tip_label', 'Tip')}:</strong> {t('popover.discard_tip', 'Hit the green button to save your task with your first comment.')}
                            </p>
                        </div>

                        <div className="flex gap-3 justify-center">
                            <Button
                                variant="outline"
                                size="sm"
                                className=""
                                onClick={handleCancel}
                                leftIcon={<Pencil size={16} />}
                                tooltip={t('popover.discard_keep_editing_tooltip', 'Return to your task and finish adding your comment.')}
                                tooltipSide='top'
                                tooltipClassName='text-left'
                            >
                                {t('popover.discard_keep_editing', 'Keep Editing')}
                            </Button>
                            <Button
                                variant="destructive"
                                size="sm"
                                className=""
                                onClick={handleDiscard}
                                leftIcon={<Trash2 size={16} />}
                                tooltip={t('popover.discard_confirm_tooltip', 'Discard your task and lose all unsaved changes. This action cannot be undone.')}
                                tooltipSide='top'
                                tooltipClassName='text-left'
                            >
                                {t('popover.discard_confirm', 'Discard Task')}
                            </Button>
                        </div>
                    </div>
                </div>
            </ResponsiveDialog.Content>
        </ResponsiveDialog>
    );
}